<script>
import InboxWrapper from '@/components/inbox/InboxWrapper.vue'

export default {
  name: 'InboxComponent',
  components: { InboxWrapper },
  props: {
    viewName: { type: String }
  },
}
</script>
<template>
  <v-container fluid>
    <InboxWrapper :view-name="viewName" />
  </v-container>
</template>
